<template>
	<div class="main">
		<div class="nav_cont">
			<div class="fh" @click="navigateBack"><i class="el-icon-arrow-left" style="margin-right: 12px;"></i>返回</div>
			<div class="fabu">{{id > 0 ? '编辑运费模版' : '添加运费模版'}}</div>
		</div>	
			<div class="formtit">基础信息</div>
			<div class="form_template">
				<el-row>
					<el-col :span="20" :offset="1">
						<el-form label-width="auto">
							   <el-form-item label="模板名称" >
									<el-col :span="23" :offset="1">
										<el-input style="padding: 0;"   class="goods_name" v-model="name" maxlength="30" show-word-limit></el-input>
									</el-col>
								</el-form-item>
				
							   <el-form-item label="计费方式" >
									<el-col :span="23" :offset="1">
										 <el-radio-group v-model="mode">
											<el-radio :label="1">按件计费</el-radio>
											<!--<el-radio :label="2">按重量</el-radio>-->
											<!--<el-radio :label="3">按体积</el-radio>-->
										</el-radio-group>
									</el-col>
								</el-form-item>
								
								<el-form-item label="包邮区域" class="classify">
									<el-col :span="23" :offset="1">
									   <el-select v-model="freearea" @change="baoyouChange" @remove-tag="baoyouRremove" style="width: 100%;" multiple placeholder="选择包邮区域">
									      <el-option
									        v-for="item,i_key in citydata"
									        :key="i_key"
									        :label="item.zh_name"
									        :value="i_key"
											:disabled="is_select(i_key)"
											>
									      </el-option>
									    </el-select>
									</el-col>
								</el-form-item>
								
								<el-form-item label="付邮区域">
									<el-col :span="23" :offset="1">
									
										 <el-table :data="formData" :header-cell-style="setHeader"  border style="width: 100%">
										          <el-table-column  label="配送区域" align="center"  width="220">
										            <template slot-scope="scope" >
														<el-tag v-for="tag_i,tag_index in scope.row.city" closable
														  type="info" @close="del_cost(tag_index,scope.$index)"  style="margin-right: 5px;">
														  {{tag_i}}
														</el-tag>
														
														 <el-button class="add_c_btn" @click="add_area(scope.$index)"   plain>
															 <i class="el-icon-plus"></i>
														 </el-button> 
														 <span class="font-selected" v-if="scope.row.city.length < 1" @click="add_area(scope.$index)">选择区域</span>
										            </template>
										          </el-table-column>
												  
												  <el-table-column
												    label="首件(个)" align="center" >
												    <template slot-scope="scope" >
												  			<el-input  placeholder="0" v-model="scope.row.first_unit" maxlength="7" oninput="value=value.replace(/[^\d]/g,'')"></el-input>									
												    </template>
												  </el-table-column>
												  
												  
												  <el-table-column
												    label="运费(元)" align="center">
												    <template slot-scope="scope">
												  		   <el-input placeholder="￥ 0.00" v-model="scope.row.first_cost" maxlength="7" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></el-input>																		
												    </template>
												  </el-table-column>
												  
												  
												  <el-table-column
												    label="续件(个)" align="center"  >
												    <template slot-scope="scope">
												  			<el-input placeholder="0" v-model="scope.row.continue_unit" maxlength="7" oninput="value=value.replace(/[^\d]/g,'')"></el-input>																													
												    </template>
												  </el-table-column>
												  
												  
												  <el-table-column
												    label="续费(元)" align="center"  >
												    <template slot-scope="scope">
														<el-input placeholder="￥ 0.00" v-model="scope.row.continue_cost" maxlength="7" oninput="value=value.match(/\d+\.?\d{0,2}/,'')"></el-input>																																														
												    </template>
												  </el-table-column>
												  
												  
												  <el-table-column
												    label="是否制定条件包邮" align="center" width="200px">
												    <template slot-scope="scope">
												  		     <el-radio-group v-model="scope.row.is_condition" >
																	<el-radio :label="1">是</el-radio>
																	<el-radio :label="0">否</el-radio>
															 </el-radio-group>			
																					 
															 <el-input v-if="scope.row.is_condition" maxlength="7" :placeholder="scope.row.unit == 1?'0':'0.00'"  @input="restrict_unit($event,scope.$index)" v-model="scope.row.quantity" style="margin-top: 10px;">
																 <template style="padding: 0 5px;" slot="prepend">满</template>
																  <el-select v-model="scope.row.unit" @change="scope.row.quantity = ''" slot="append" >
																       <el-option label="件" value="1"></el-option>
																       <el-option label="元" value="2"></el-option>
																   </el-select>
															  </el-input>
												    </template>
												  </el-table-column>
												  
												  
												  <el-table-column label="操作" align="center" width="60px">
												    <template slot-scope="scope">
														<i style="font-size: 20px;cursor: pointer;" class="el-icon-delete" @click="del_area(scope.$index)"></i>
												    </template>
												  </el-table-column>
												  
										  </el-table>
										
										<div class="add_item" @click="addCheckBox">
											新增配送区域
										</div>
										
										
									</el-col>
								</el-form-item>
				
						</el-form>
					</el-col>
					
					<el-col :span="24" :offset="1">
						<div class="tishi" :span="24" :offset="1">*温馨提示：以上包邮与付邮地区均未选择的地区则默认为不配送地区</div>
						
						
						<div class="save_btn" @click="saveTemplate">保存</div>
					</el-col>
				</el-row>
			</div>
			

			<!-- 选择区域 -->
			<div class="distribution_area"> 
				<el-dialog width="600px" title="选择配送区域" :visible.sync="show" :before-close="close" :close-on-click-modal="false">
					 <div class="quyu">
						 <div :class="(c_area.is_checked || freearea.includes(c_index))?'qy_item qy_item_d':checked_arr.includes(c_index)?'qy_item qy_item_s':'qy_item'" 
						 v-for="(c_area,c_index) in citydata" 
						 :key="c_index" @click="check_area(c_index)">
						
						 {{c_area.zh_name}}
						 
						 </div>
					 </div>
					 <div class="bottom_bottom">
						 <div>已选{{checked_arr.length}}个区域</div>
						 <el-button type="primary" @click="verify_area()">确定</el-button>
					 </div>
				</el-dialog>
			</div>
			
	</div>
	
</template>

<script>
	import {baseURL} from '@/config';
	import detailNav from '@/components/detail-nav.vue';
	import {
		getCity,addOrEditTemplate,getDetail
	} from '@/api/freight_template';
	export default {
		components: {
			detailNav
		},
		data() {
			return {
				imgpath: baseURL + '/public/images',
				id:0,
				name:'',
				mode:1,
				citydata:[],//全部地区
				freearea:[],//包邮地区
				formData:[],//付费地区设置
				show:false,
				check_index:0,//付费规则模版
				checked_arr:[],//临时当前选中的
			}
		},
		mounted() {
			var that = this;
			let query = this.$route.query;
			if (query.freight_id) {
				that.id = query.freight_id;
			}
			getCity({}).then(res => {
				if(res.code == 0){
					that.citydata = res.data;
					if(that.id == 0){
						for (let index in that.citydata) {
						    that.citydata[index].is_checked = false;
						}
						that.addCheckBox();
					}else{
						getDetail({freight_id:that.id}).then(res=>{
							 if(res.code == 0){
								 that.name = res.data.name;
								 that.freearea = res.data.freeareaid.map(item => String(item));
								 that.formData = res.data.forms;
								
								let selected_arr = [];
								that.formData.forEach((element, index) => {
									selected_arr = [...selected_arr, ...element.cityid];;
								});
								 
								 for (let index in that.citydata) {
									if(selected_arr.includes(that.citydata[index].id)){
										 that.citydata[index].is_checked = true;
									}else{
										 that.citydata[index].is_checked = false;
									}
								 }
							 }else{
								 that.$message.error(res.message);
								 that.navigateBack();
							 }
						})
					}
				}
			});
		},
		methods: {
			//表头样式
			setHeader(){
				return 'background:#F5F7FA;border:none;'
			},
			navigateBack() {
				// this.$router.go(-1)
				this.$router.push({
					path: '/order/postage-list',
					query: {
					}
				});
			},
			//关闭选择地区
			close() {
				this.show = false;
				this.checked_arr = [];
			},
			 // 显示选择可配送区域弹窗
			addCheckBox() {
				let temp = {
					'city': [],
					'cityid': [],
					'first_unit': '1',
					'first_cost': '',
					'continue_unit': '1',
					'continue_cost': '',
					'is_condition': 0,
					'unit': "1",
					'quantity': ''
				};
				this.formData.push(temp);
			},
			// 显示弹框
			add_area(form_index){
				this.show = true;
				this.check_index = form_index;
			},
			// 选择地区
			check_area(c_index){
				
				if(this.citydata[c_index].is_checked || this.freearea.includes(c_index)){
					return false;
				}
				
				const _index = this.checked_arr.indexOf(c_index);
				if (_index !== -1) {
					this.checked_arr.splice(_index,1);
				}else{
					this.checked_arr.push(c_index);
				}
				console.log(this.checked_arr);
				
			},
			// 是否可选
			is_select(s_index){
				
				if(this.freearea.includes(s_index)){
					return false;
				}
				
				if(this.citydata[s_index].is_checked){
					return true;
				}
				
			},
			//付费确认选择地区
			verify_area(){
				//循环全部地区，是否选中包邮
				for (let index in this.citydata) {
					if (this.checked_arr.includes(index)) {
					  this.citydata[index].is_checked = true;
					  this.formData[this.check_index].city.push(this.citydata[index].zh_name);
					  this.formData[this.check_index].cityid.push(index);
					}
				}
				this.$forceUpdate();
				this.close();
				console.log(this.formData);
			},
			//包邮选择
			baoyouChange(value){
				console.log(this.freearea);
			},
			// 包邮取消选择
			baoyouRremove(value){
			},
			// 保存模版
			saveTemplate(){
				console.log(this.formData);
				var that = this;
				
				if (this.name == '' || (this.name.length > 0 && this.name.trim().length == 0)) {
						this.$message.error('请输入模板名称');
						return;
				}
				if(this.formData.length < 1){
					this.$message.error('请添加付邮区域');
					return;
				}
				for (var i = 0; i < this.formData.length; i++) {
					if (this.formData[i].cityid.length <= 0) {
						this.$message.error('请选择配送区域');
						return;
					}
					if (this.formData[i].first_unit <= 0) {
						this.$message.error('首件数量不能小于等于0');
						return;
					}
					if (this.formData[i].first_cost == '') {
						this.$message.error('首件运费不能为空');
						return;
					}
					if (this.formData[i].continue_unit <= 0) {
						this.$message.error('续件数量不能小于等于0');
						return;
					}
					if (this.formData[i].continue_cost <= 0) {
						this.$message.error('续件运费不能小于等于0');
						return;
					}
					if(this.formData[i].is_condition == 1){
						if (this.formData[i].quantity <= 0) {
							this.$message.error('制定条件包邮不能小于等于0');
							return;
						}
					}
				}
				
				//获取不配送区域
				let NotDeliver = '';
				for (let index in this.citydata) {
					if (!this.freearea.includes(index) && !this.citydata[index].is_checked) {
					    NotDeliver+='【'+this.citydata[index].zh_name+'】 ';
					}
				}
				if(NotDeliver != ''){
				  var new_NotDeliver = '当前运费模版中'+NotDeliver+'默认为不配送地区';
				}else{
				  var new_NotDeliver = '当前运费模版中所有地区均配送';
				}
				
				this.$confirm(new_NotDeliver, '提示', {
				  confirmButtonText: '确认保存',
				  cancelButtonText: '取消',
				}).then(() => {
					//保存请求
					let data = {
						 freight_id: that.id,
						 name: that.name,
						 mode: that.mode,
						 freeareaid: that.freearea,
						 forms: that.formData
					};
					
					addOrEditTemplate(data).then(res => {
						if(res.code == 0){
							this.$message.success('保存成功');
							this.navigateBack();
						}else{
							this.$message.error(res.message);
						}
					});
				
				}).catch(() => {});
				
			},
			//删除整条付费规则
			del_area(itemIndex){
				for (let index in this.formData[itemIndex]['cityid']) {
					this.citydata[this.formData[itemIndex]['cityid'][index]].is_checked = false;
				}
				this.formData.splice(itemIndex,1);
			},
			//付费配送区域删除
			del_cost(tagIndex, itemIndex) {
				this.citydata[this.formData[itemIndex]['cityid'][tagIndex]].is_checked = false;
				this.formData[itemIndex]['cityid'].splice(tagIndex, 1);
				this.formData[itemIndex]['city'].splice(tagIndex, 1);
			},
			// 显示包邮单位小数点
			restrict_unit(value,index){
				if(this.formData[index].unit == '2'){
					this.formData[index].quantity = (value.match(/^\d*(\.?\d{0,2})/g)[0]) || null;
				}else{
					value = value.replace(/[^0-9]/g, "")
					if(value.indexOf(0) == 0){
						value = '';
					}
					this.formData[index].quantity = value;
				}
				
			}
			
		}
	}
	
</script>

<style>
	.main {
		background: #ffffff;
	}
	.main .nav_cont {
		width: 100%;
		height: 60px;
		border-radius: 4px;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EEEEEE;
		margin-bottom: 15px;
	}
	.formtit {
		width: 100px;
		height: 25px;
		border-left: 3px solid #409EFF;
		line-height: 25px;
		padding-left: 15px;
		margin-bottom: 23px;
	}
	.fh {
		width: 92px;
		height: 23px;
		text-align: center;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 23px;
		border-right: 1px solid #CCCCCC;
		margin-right: 21px;
		cursor: pointer;
	}
	
	.form_template .el-upload--picture-card {
		width: 90px;
		height: 90px;
		line-height: 90px;
		border: 0;
	}
	
	.form_template .el-form-item__label::before {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
	}
	
	.classify .el-form-item__label::before{
		content: '';
	}
	
	.add_c_btn{
		background: rgb(230, 241, 252);
		width: 24px;
		height: 24px;
		padding: 0;
		text-align: center;
		line-height: 24px;
		border: 1px solid #A3D0FD;
		color: #1989FA;
	}
	.add_c_btn.el-button.is-plain:focus, .el-button.is-plain:hover {
		background: #409EFF;
		color: #fff;
	}  
	
	.form_template .el-input-group__append{
		width: 60px;
		background-color: #fff;
		padding-left: 15px;
		padding-right: 20px;
	}
	.form_template  .el-input-group__prepend{
		padding: 0 10px;
	}
	.add_item{
		width: 105px;
		height: 40px;
		background: #E6F1FC;
		border-radius: 4px;
		border: 1px solid #A3D0FD;
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #1989FA;
		text-align: center;
		line-height: 40px;
		margin-top: 10px;
		cursor: pointer;
	}
	.tishi{
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #666666;
	}
	.save_btn{
		width: 110px;
		height: 40px;
		background: #0486FE;
		border-radius: 4px;
		text-align: center;
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 40px;
		margin-top: 30px;
		margin-bottom: 30px;
		cursor: pointer;
	}
	.quyu{
		display:flex;
		flex-wrap: wrap;
	}
	.distribution_area .el-dialog__body{
		padding: 20px;
	}
	.qy_item{
		padding: 0 14px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #D8DCE6;
		font-size: 12px;
		font-family: AlibabaPuHuiTi_2_55_Regular;
		color: #354052;
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		margin-right: 10px;
		margin-bottom: 10px ;
	}
	.qy_item_d{
		background: #F5F7FA;
		color: #CCCCCC;
		cursor: not-allowed;
	}
	.qy_item_s{
		background: #E6F1FC;
		border: 1px solid #A3D0FD;
		color: #A3D0FD;
	}
	.bottom_bottom{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 30px;
	}
	.el-form-item__content .goods_name .el-input__suffix {
		height: 100%;
		right: -44px;
		transition: all .3s;
		pointer-events: none;
		top:8px;
	}
	.font-selected{
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		color: #0486FE;
		margin-left: 7px;
		cursor: pointer;
	}
</style>